import { IconButton, Chip, useTheme } from '@mui/material'
import { IconArrowLeft } from '@tabler/icons-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  HeaderContainer,
  HeaderTitle,
  HeaderBadgeContainer,
} from '../styled/SavedMenuDetail.styled'

interface SavedMenuDetailHeaderProps {
  menuName: string
  type?: 'User Provided' | 'Scan Only'
  savedDate?: string
}

const SavedMenuDetailHeader: React.FC<SavedMenuDetailHeaderProps> = ({
  menuName,
  type,
  savedDate,
}): JSX.Element => {
  const navigate = useNavigate()
  const theme = useTheme()

  const handleBackClick = (): void => {
    navigate(-1)
  }

  return (
    <HeaderContainer>
      <IconButton
        onClick={handleBackClick}
        sx={{ 
          padding: '8px',
          marginLeft: '-8px',
        }}
        aria-label="go back"
      >
        <IconArrowLeft size={24} stroke={2} color={theme.palette.grey[800]} />
      </IconButton>

      <HeaderTitle>{menuName}</HeaderTitle>

      <HeaderBadgeContainer>
        {type && (
          <Chip 
            label={type} 
            size="small"
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.common.white,
              fontSize: { xs: '11px', sm: '12px' },
              fontWeight: 500,
              height: { xs: '24px', sm: '26px' },
            }}
          />
        )}
        {savedDate && (
          <Chip
            label={savedDate}
            size="small"
            variant="outlined"
            sx={{
              borderColor: theme.palette.grey[400],
              color: theme.palette.grey[700],
              fontSize: { xs: '11px', sm: '12px' },
              fontWeight: 500,
              height: { xs: '24px', sm: '26px' },
            }}
          />
        )}
      </HeaderBadgeContainer>
    </HeaderContainer>
  )
}

export default SavedMenuDetailHeader
